import { render, staticRenderFns } from "./AdminProd.vue?vue&type=template&id=296f81bd&scoped=true&"
import script from "./AdminProd.vue?vue&type=script&lang=js&"
export * from "./AdminProd.vue?vue&type=script&lang=js&"
import style0 from "./AdminProd.vue?vue&type=style&index=0&id=296f81bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f81bd",
  null
  
)

export default component.exports